import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import InputLabel from '../../../rxlib/components/input-label';
import Redirecionar from '../../../rxlib/components/redirecionar';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import ButtonsCrud from '../../../rxlib/components/buttons/buttons-crud';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { SelectLabel } from '../../../rxlib/components/select/select-label';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { ApiError, CadastroProps, RequestItemLicenca, ItemLicenca } from '../../../services/tipos';

function ItemLicencaCadastro(props: CadastroProps) {
    const [salvo, setSalvo] = useState<boolean>(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);

    const [itemLicenca, setItemLicenca] = useState<ItemLicenca>({
        id: '',
        nome: '',
        chave: '',
        tipoControle: '',
    });

    const { register, handleSubmit } = useForm<ItemLicenca>();

    const handleHideWarning = () => setShowWarning(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Itens da licença', link: '/itemlicenca' },
        { texto: props.match.params.action ? 'Visualização' : props.match.params.id ? 'Edição' : 'Novo', link: '' },
    ];

    const tiposControle: any = [
        { id: '', nome: 'Selecione' },
        { id: 1, nome: 'Valor' },
        { id: 2, nome: 'Flag' },
        { id: 3, nome: 'Personalizado' },
    ];

    const temPermissao = props.match.params.action
        ? usuarioTemPermissao(token, 'itens_licenca_visualizar')
        : props.match.params.id
            ? usuarioTemPermissao(token, 'itens_licenca_editar')
            : usuarioTemPermissao(token, 'itens_licenca_novo');

    useEffect(() => {
        if (temPermissao) {
            if (props.match.params.id) {
                api.get(`/ItemLicenca/${props.match.params.id}`)
                    .then(response => {
                        setItemLicenca({
                            id: response.data.id,
                            nome: response.data.nome,
                            chave: response.data.chave,
                            tipoControle: response.data.tipoControle,
                        });
                    }).catch((error: AxiosError<ApiError>) => {
                        tratarErro(error);
                    });
            }
        }
    }, [props.match.params.id, temPermissao]);

    const onSubmit: SubmitHandler<ItemLicenca> = data => {
        setCarregando(true);

        const dados: RequestItemLicenca =
            props.match.params.id
                ? {
                    id: data.id,
                    nome: data.nome,
                    chave: data.chave,
                    tipoControle: parseInt(data.tipoControle),
                }
                : {
                    nome: data.nome,
                    chave: data.chave,
                    tipoControle: parseInt(data.tipoControle),
                }

        props.match.params.id
            ? editar(dados)
            : salvar(dados);
    }

    function salvar(data: RequestItemLicenca) {
        api.post('/ItemLicenca', data)
            .then(response => {
                setSalvo(true);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
    }

    function editar(data: RequestItemLicenca) {
        api.put('/ItemLicenca', data)
            .then(response => {
                setSalvo(true);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
    }

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, 'Não foi possível salvar o item da licença: '));
        setShowWarning(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form onSubmit={handleSubmit(onSubmit)} className='rxlib-form'>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-12'>
                                <h6>{props.match.params.action ? 'Visualizar' : props.match.params.id ? 'Editar' : 'Novo'} item da licença</h6>
                            </div>
                        </div>
                        {
                            props.match.params.id
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-1'>
                                        <InputLabel
                                            name='id'
                                            type='text'
                                            id='inputId'
                                            maxLength={50}
                                            readOnly={true}
                                            label='Código:'
                                            autoFocus={false}
                                            defaultValue={itemLicenca.id}
                                            placeholder='Código do item da licença'
                                            referencia={register({ required: true })} />
                                    </div>
                                </div>
                                : ''
                        }
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    name='nome'
                                    type='text'
                                    label='Nome:'
                                    id='inputNome'
                                    maxLength={100}
                                    autoFocus={true}
                                    defaultValue={itemLicenca.nome}
                                    placeholder='Nome do item da licença'
                                    referencia={register({ required: true })}
                                    readOnly={props.match.params.action === 'view'} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    name='chave'
                                    label='Chave:'
                                    maxLength={100}
                                    id='inputChave'
                                    autoFocus={false}
                                    defaultValue={itemLicenca.chave}
                                    placeholder='Chave do item da licença'
                                    referencia={register({ required: true })}
                                    readOnly={props.match.params.action === 'view'} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <SelectLabel
                                    foco='nao'
                                    name='tipoControle'
                                    itens={tiposControle}
                                    id='inputTipoControle'
                                    ariaLabel='TipoControle'
                                    label='Tipo de controle:'
                                    campoExibicaoRegistro='nome'
                                    campoIdentificadorRegistro='id'
                                    action={props.match.params.action}
                                    referencia={register({ required: true })}
                                    valorSelecionado={itemLicenca.tipoControle} />
                            </div>
                        </div>
                        <ButtonsCrud
                            carregando={carregando}
                            styleButton='btn-rxlib'
                            linkCancelarVoltar='/itemlicenca'
                            visualizar={props.match.params.action === 'view'} />
                    </div>
                </form>
                <ModalWarning
                    show={showWarning}
                    message={messageWarning}
                    onHide={handleHideWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <Redirecionar
                    se={salvo}
                    para='/itemlicenca' />
            </RxlibLayout>
        </>
    );
}

export default ItemLicencaCadastro;